<template lang="pug">
  v-layout(justify-center)
    v-flex(xs12)
      v-layout(justify-start)
        h2(class="card__title") {{$t('common.btnReporting')}}
      template(v-if="reports.length > 10")
        v-data-table(
          :headers="headers",
          :items="reports",
          :loading="loading",
          :no-data-text="$t('common.noDataText')",
          :rows-per-page-text="$t('ReportingPage.PaginationBlock.rowPage')",
          :rows-per-page-items="[10, 25, 50]")
          template(slot="items" slot-scope="props")
            td {{ props.index + 1 }}
            td {{ props.item.name }}
            td {{ props.item.description }}
            td
              router-link(
                :to="`/report/${props.item.reportKey}`",
                @click="onClick(props.item.name, props.item.inn, props.item.okpo)") {{$t('ReportingPage.ButtonReporting.passReporting')}}
          template(v-slot:pageText="props").
            {{$t('ReportingPage.PaginationBlock.noteFrom')}} {{ props.pageStart }}
            {{$t('ReportingPage.PaginationBlock.notePo')}} {{ props.pageStop }}
            {{$t('ReportingPage.PaginationBlock.noteFroms')}} {{ props.itemsLength }}
            {{$t('ReportingPage.PaginationBlock.noteEnd')}}
      template(v-else)
        v-data-table(
          :headers="headers",
          :items="reports",
          :loading="loading",
          :no-data-text="$t('common.noDataText')",
          hide-actions,
          :rows-per-page-text="$t('ReportingPage.PaginationBlock.rowPage')",
          :rows-per-page-items="[10, 25, 50]")
          template(slot="items" slot-scope="props")
            td {{ props.index + 1 }}
            td {{ props.item.name }}
            td {{ props.item.description }}
            td(class="status-text-wrap")
              p(class="status-text") {{ formatDate(Date.now()) }}
              p(class="status-text status-text--success") {{$t('ReportingPage.PaginationBlock.reportSubmitted')}} {{ formatDate(Date.now()) }}
              p(class="status-text status-text--failure") {{$t('ReportingPage.PaginationBlock.expired')}}
            td
              template(v-if='true')
                router-link(
                  :to="`/report/${props.item.reportKey}`",
                  @click="onClick(props.item.name, props.item.inn, props.item.okpo)") {{$t('ReportingPage.ButtonReporting.passReporting')}}
          template(v-slot:pageText="props").
            Записи: c {{ props.pageStart }} по {{ props.pageStop }} из {{ props.itemsLength }}
</template>

<script>
import moment from 'moment'
export default {
  name: 'Reports',
  data: () => ({
    headers: [
      {
        text: '№',
        sortable: false,
        value: 'index'
      },
      {
        text: this.$t('common.listForm'),
        value: 'name'
      },
      {
        text: this.$t('common.nameForm'),
        value: 'description'
      },
      {
        text: this.$t('common.sendBefore'),
        value: 'pass-until'
      },
      {
        text: this.$t('common.actionDo'),
        value: 'action',
        sortable: false
      }
    ]
  }),
  mounted() {
    this.$store.dispatch('GET_REPORTS')
    this.$store.dispatch('GET_MY_REPORTS')
  },
  computed: {
    reports() {
      return this.$store.state.reporting.reports
    },
    loading() {
      return this.$store.state.reporting.loading
    }
  },
  methods: {
    onClick(name, inn, okpo) {
      this.$store.commit('SET_REPORT_NAME', name)
      this.$store.commit('SAVE_RESPONDENT_PARAMS', { inn, okpo })
    },
    formatDate(date) {
      return moment(date).format('Do MMMM YYYY')
    }
  }
}
</script>
<style scoped>
.status-text-wrap {
  white-space: nowrap;
}
.status-text {
  margin: 0;
}
.status-text--success {
  color: #03be43;
}
.status-text--failure {
  color: #ff3b30;
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage/components/Reports/Reports.vue